import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ReCAPTCHA from "react-google-recaptcha";
import { message } from "antd";
import { FaXmark } from "react-icons/fa6";

import "./styles.scss";
import {
  ForgotPasswordAction,
  ForgotPasswordReset,
} from "../../../store/slices/auth/forgotPassword";

const ForgotPasswordCard = ({ setShowForgotPassword }) => {
  const [email, setEmail] = useState("");
const [emailError, setEmailError] = useState("");
  const [captchaError, setCaptchaError] = useState(" ");
  const [isChecked, setIsChecked] = useState(false);

  const dispatch = useDispatch();
  const {
    data: forgotPasswordData,
    success: forgotPasswordSuccess,
    error: forgotPasswordError,
    isLoading,
  } = useSelector((state) => state.forgotPassword);
  const isDevPlatform = process.env.REACT_APP_ENVIRONMENT === 'dev' || process.env.REACT_APP_ENVIRONMENT === 'local';

  const validateEmail = (emailmsg) => {
    const regex = /\S+@\S+\.\S+/;
    return regex.test(emailmsg);
  };

  const handleClose = () => {
    setShowForgotPassword(false);
  };

  const onEmailChange = (e) => {
    if (e.target.value.match("^[a-zA-Z0-9_@./#&+-]*$")) {
      setEmail(e.target.value);
    //   setEmailError("");
    }
  };

  const handleSubmit = () => {
    const validEmail = validateEmail(email);

    if (!validEmail) {
      setEmailError("*Please enter a valid email!");
    } else if (!isChecked) {
      setCaptchaError("*Please verify that you are not a robot.");
    } else {
      const payload = {
        email: email,
      };

      dispatch(ForgotPasswordAction(payload));
      setCaptchaError("");
    }
  };

  const onCaptchaChange = (e) => {
    setIsChecked(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  useEffect(() => {
    if (forgotPasswordSuccess && forgotPasswordData?.message) {
      message.success(forgotPasswordData?.message);
      dispatch(ForgotPasswordReset());
      handleClose();
    }
  }, [forgotPasswordSuccess]);

  useEffect(() => {
    if (forgotPasswordError?.message) {
      message.error(forgotPasswordError?.message);
    }
  }, [forgotPasswordError?.message]);

  useEffect(() => {
        if (isDevPlatform) {
            setIsChecked(true);
        }
    }, [isDevPlatform])

  return (
    <div className="forgot-password-card">
      <div className="close-screen-button">
        <FaXmark className="close-icon" onClick={() => handleClose()} />
      </div>
      <div className="card-title">Forgot Password</div>
      <div className="card-description">
        Please enter your email address to receive instructions on how to reset
        your password.
      </div>
      <div className="forgot-password-body-section">
      <div className="forgot-password-email-section">
        <input
          className="form-input"
          name="login"
          type="email"
          placeholder="Enter your Email Id"
          onChange={onEmailChange}
          value={email}
          onKeyDown={handleKeyDown}
        />
      </div>
      {emailError && <div className="error-message">{emailError}</div>}
      {process.env.REACT_APP_ENVIRONMENT === "production" && (<div className="re-captcha-section">
        <ReCAPTCHA
          name="verified"
          className={`recaptcha ${isChecked ? "red-class" : ""}`}
          sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA}
          onChange={(e) => onCaptchaChange(e)}
          size="normal"
          theme="light"
          onExpired={() => setIsChecked(false)}
          onError={() => setIsChecked(false)}
        />
        {captchaError && <div className="error-message">{captchaError}</div>}
      </div>)}
      </div>
      <div className="card-buttons-section">
        <div
          className="card-button reset-password"
          onClick={() => handleSubmit()}
        >
          {isLoading ? "Loading" : "Reset Password"}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordCard;
